import React from 'react';
import { Empty } from 'antd';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';

import SpinLoading from 'common/components/spin-loading';
import BookingTables from './booking-tables';
import useTableFilters from './useTableFilters';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    lineHeight: '24px',
    color: 'rgba(0, 0, 0, 0.85)',
    fontWeight: 600,
    marginBottom: 24,
  },
  loading: {
    height: 450,
  },
  empty: {
    marginTop: '10%',
  },
}));

export default function BookingList({ landlordId }) {
  const { t } = useTranslation(['landlord', 'cms']);
  const classes = useStyles();
  const {
    queryBookingCountData,
    queryBookingCountLoading,
    bookingType,
    setBookingType,
    bookingStage,
    setBookingStage,
    otherTableFilter,
    setOtherTableFilter,
    tableData,
    tableLoading,
    refetchTableData,
  } = useTableFilters({ landlordId });

  return (
    <Choose>
      <When condition={queryBookingCountLoading}>
        <header className={classes.title}>{t('cms:cms.landlord.detail.bookings.tab')}</header>
        <SpinLoading className={classes.loading} />
      </When>
      <When
        condition={
          queryBookingCountData?.landlord?.manualCount?.totalCount > 0 ||
          queryBookingCountData?.landlord?.messagePropertyCount?.totalCount > 0
        }
      >
        <BookingTables
          hasManual={queryBookingCountData?.landlord?.manualCount?.totalCount > 0}
          hasMessageProperty={queryBookingCountData?.landlord?.messagePropertyCount?.totalCount > 0}
          bookingType={bookingType}
          setBookingType={setBookingType}
          bookingStage={bookingStage}
          setBookingStage={setBookingStage}
          otherTableFilter={otherTableFilter}
          setOtherTableFilter={setOtherTableFilter}
          tableData={tableData}
          tableLoading={tableLoading}
          refetchTableData={refetchTableData}
        />
      </When>
      <Otherwise>
        <header className={classes.title}>{t('cms:cms.landlord.detail.bookings.tab')}</header>
        <Empty
          className={classes.empty}
          description={t('cms:this_landlords_do_not_have_any_booking_now')}
        />
      </Otherwise>
    </Choose>
  );
}
